(function () {
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-label-copied]");
    if (!btn) return;

    const url = window.location.href;

    navigator.clipboard.writeText(url).then(function () {
    });
  });
})();
